import { render, staticRenderFns } from "./datasets.vue?vue&type=template&id=24d685fc&scoped=true"
import script from "./datasets.vue?vue&type=script&lang=js"
export * from "./datasets.vue?vue&type=script&lang=js"
import style0 from "./datasets.vue?vue&type=style&index=0&id=24d685fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d685fc",
  null
  
)

export default component.exports